import { z } from 'zod/v4';

export const AdminGetAllowedOriginParamsSchema = z.object({
  id: z.string().min(1),
});

export type AdminGetAllowedOriginParams = z.infer<
  typeof AdminGetAllowedOriginParamsSchema
>;
